export const getRootElement = () => {
  return document.getElementById("irobot-embedded-interactive-experience")
};

export default {
  getRootElement,
}
